import React  from 'react';
import classes from './classes.module.scss';
import { PurchaseSvgIcon } from '../../sprites';

interface MarketingImageProps {
  offers: Array<{subtitle: string; title: string}>,
}

const MarketingImage:React.FC<MarketingImageProps> = ({ offers }) => {
  const renderMarketingImage = () => {
    if (offers?.length > 1) return <PurchaseSvgIcon className={ classes.marketingImage2Items } id="marketing_img_2_items"  />;
    return <div className={ classes.marketingImage1ItemContainer }><PurchaseSvgIcon className={ classes.marketingImage1Item } id="marketing_img_1_item" /></div>;
  };

  return renderMarketingImage();
};

export default MarketingImage;
